import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-bookme-landing-page',
  templateUrl: './bookme-landing-page.component.html',
  styleUrls: ['./bookme-landing-page.component.scss'],
  standalone: false,
})
export class BookmeLandingPageComponent implements OnInit {
  url = '';

  constructor(private http: HttpClient) {}

  ngOnInit(): void {
    console.log('inside init');
  }

  onSubmit(f: NgForm) {
    return this.http.post<unknown>(this.url, f.value).subscribe(() => {
      console.log();
    });
  }
}
